import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const DotnetText = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M1.5031 11.1078C1.36335 11.1078 1.24456 11.0613 1.14674 10.9681C1.04891 10.8726 1 10.7592 1 10.6279C1 10.4941 1.04891 10.3795 1.14674 10.284C1.24456 10.1884 1.36335 10.1407 1.5031 10.1407C1.64518 10.1407 1.76514 10.1884 1.86296 10.284C1.96312 10.3795 2.0132 10.4941 2.0132 10.6279C2.0132 10.7592 1.96312 10.8726 1.86296 10.9681C1.76514 11.0613 1.64518 11.1078 1.5031 11.1078Z"
      fill="currentColor"
    />
    <path
      d="M7.08978 11.029H6.18143L3.78818 7.2534C3.72762 7.15788 3.67754 7.05877 3.63794 6.95608H3.61698C3.63561 7.06593 3.64493 7.30116 3.64493 7.66178V11.029H2.84136V5.89217H3.80914L6.12201 9.57825C6.21983 9.73109 6.28272 9.83617 6.31068 9.89349H6.32468C6.30136 9.75736 6.2897 9.52691 6.2897 9.20212V5.89217H7.08978V11.029Z"
      fill="currentColor"
    />
    <path
      d="M11.003 11.029H8.1905V5.89217H10.8912V6.61577H9.022V8.07015H10.7444V8.79017H9.022V10.309H11.003V11.029Z"
      fill="currentColor"
    />
    <path d="M15 6.61577H13.5606V11.029H12.7291V6.61577H11.2931V5.89217H15V6.61577Z" fill="currentColor" />
  </Icon>
));

export default DotnetText;
